export enum GridWidth {
  Desktop = 'var(--desktop-grid)',
}
